import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(
    "Supabase is not configured. Copy .env.example to .env.local and fill in " +
      "VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.",
  );
}

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,

    /* Named explicitly rather than left to the default. iOS Safari suspends a
       backgrounded page and stops its timers, so the token refresh that
       should have happened while the phone was in a pocket never runs. On
       return, supabase-js reads the session back from here — but only if it
       is looking in the same place it wrote it, which a default key derived
       from the project URL does not guarantee across app updates. */
    storage: window.localStorage,
    storageKey: "frontlot.auth",

    /* No magic links or OAuth redirects in this app, so there is never a
       session in the URL to detect. Leaving it on makes supabase-js parse
       every page load looking for one. */
    detectSessionInUrl: false,
  },
});
